import { httpInterceptor } from '../../service/http-interceptor';
import { normalizePlannerGetByIdPathSegment } from './planner-getbyid-path';
import { sanitizeSavePlanPayload } from './planner-save-plan-body';

export class PlannerService {
  static ENDPOINTS = {
    GET_ALL_CHANNEL: 'planner/getallchannel',
    GET_ALL_TASK: 'planner/getalltask',
    SAVE_PLAN: 'planner/saveplan',
    UPDATE_PROCESS: 'planner/updateprocess',
    ARCHIVE_PLAN: 'planner/archiveplan',
    GET_BY_WORKTICKET_ID: 'planner/getbyid/',
    DELETE_BY_WORKTICKET_ID: 'planner/delete/',
    GET_STATUS_LOG: 'planner/getstatuslog/',
    GET_COMPLETION_STATUS: 'planner/getcompletionstatus',
    GET_PROCESSING_PARAMETERS: 'Mobile/partdocuments/',
  };

  // Helper method to adjust till date based on cycle time changes
  static adjustTillDateForCycleTime(existingProgram, newCycleTime) {
    if (!existingProgram.cycleTime || !existingProgram.toDate || newCycleTime === undefined) {
      return existingProgram.toDate;
    }
    
    const cycleTimeDifference = newCycleTime - existingProgram.cycleTime;
    if (cycleTimeDifference === 0) {
      return existingProgram.toDate; // No change needed
    }

    const currentToDate = new Date(existingProgram.toDate);

    if (cycleTimeDifference > 0) {
      // Cycle time increased - add days to till date
      const daysToAdd = Math.ceil(cycleTimeDifference / 24); // Assuming cycle time is in hours
      currentToDate.setDate(currentToDate.getDate() + daysToAdd);
      console.log(`Cycle time increased by ${cycleTimeDifference} hours, adding ${daysToAdd} days to till date`);
    } else {
      // Cycle time decreased - subtract days from till date
      const daysToSubtract = Math.ceil(Math.abs(cycleTimeDifference) / 24);
      currentToDate.setDate(currentToDate.getDate() - daysToSubtract);
      console.log(`Cycle time decreased by ${Math.abs(cycleTimeDifference)} hours, subtracting ${daysToSubtract} days from till date`);
    }
    
    return currentToDate.toISOString();
  }

  static async getAllChannel(data) {
    return httpInterceptor.get(this.ENDPOINTS.GET_ALL_CHANNEL);
  }

  static async getAllTask(
    data = {
      // workTicketNumber: 'string',
      // workTicketName: 'string',
      // plannedStartDate: '2025-02-15T00:05:48.799Z',
      // plannedEndDate: '2025-02-15T00:05:48.799Z',
    },
  ) {
    return httpInterceptor.post(this.ENDPOINTS.GET_ALL_TASK, data);
  }

  static async savePlan(data) {
    return httpInterceptor.post(this.ENDPOINTS.SAVE_PLAN, sanitizeSavePlanPayload(data));
  }

  static async archivePlan(data) {
    return httpInterceptor.post(this.ENDPOINTS.ARCHIVE_PLAN, data);
  }

  static async updateProcess(data) {
    // Check if cycle time is being updated and adjust till date accordingly
    if (data.cycleTime !== undefined && data.id) {
      try {
        console.log('Cycle time update detected in updateProcess:', {
          programId: data.id,
          newCycleTime: data.cycleTime
        });
        // Get existing program data to compare cycle times
        const existingProgramResponse = await this.getByWorkTicketId(data.id);
        if (existingProgramResponse && existingProgramResponse.response) {
          const existingProgram = existingProgramResponse.response;
          console.log('Fetched existing program data for cycle time adjustment:', existingProgram);
          // Check if cycle time actually changed
          if (existingProgram.cycleTime !== undefined && existingProgram.cycleTime !== data.cycleTime) {
            console.log('Cycle time changed in updateProcess:', {
              oldCycleTime: existingProgram.cycleTime,
              newCycleTime: data.cycleTime,
              change: data.cycleTime - existingProgram.cycleTime
            });
            
            // Adjust to date based on cycle time change
            const adjustedToDate = this.adjustTillDateForCycleTime(existingProgram, data.cycleTime);
            data.toDate = adjustedToDate;

            console.log('Adjusted to date in updateProcess:', {
              originalTo: existingProgram.toDate,
              newTo: adjustedToDate,
              cycleTimeChange: data.cycleTime - existingProgram.cycleTime
            });
          }
        }
      } catch (error) {
        console.warn('Could not fetch existing program data for cycle time adjustment:', error);
        // Continue with the update even if we can't fetch existing data
      }
    }
    
    return httpInterceptor.post(this.ENDPOINTS.UPDATE_PROCESS, sanitizeSavePlanPayload(data));
  }

  static async getByWorkTicketId(id) {
    const pathId = normalizePlannerGetByIdPathSegment(id);
    return httpInterceptor.get(`${this.ENDPOINTS.GET_BY_WORKTICKET_ID}${pathId}`);
  }

  static async deleteByWorkTicketId(id) {
    return httpInterceptor.delete(`${this.ENDPOINTS.DELETE_BY_WORKTICKET_ID}${id}`);
  }

  static async getWorkTicketStatusLog(workTicketNumber) {
    return httpInterceptor.get(`${this.ENDPOINTS.GET_STATUS_LOG}${workTicketNumber}`);
  }

  static async getProcessCompletionStatus() {
    return httpInterceptor.get(this.ENDPOINTS.GET_COMPLETION_STATUS);
  }

  static getProcessingParametersUrl(workTicketNumber, processingParameters) {
    if (!workTicketNumber) return null;

    const encoded = encodeURIComponent(workTicketNumber);
    return httpInterceptor.get(
      `${this.ENDPOINTS.GET_PROCESSING_PARAMETERS}${encoded}${processingParameters}`,
    );
  }
}
